var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-tabs-view',{attrs:{"tabs":_vm.Tabs}})
}
var staticRenderFns = []

export { render, staticRenderFns }